module.exports = __webpack_public_path__ + "img/manager.be385fe0.svg";